/* tslint:disable */
/* eslint-disable */
/**
 * ProjectOne API
 * API for Classical Conversations content and communities.  # Service URLs In local dev: - [The **local backend**](http://0.0.0.0:8080/) defaults to running on port 8080. - [The **local frontend**](http://0.0.0.0:3000/) defaults to running on port 3000.  In the DEV environment: - [The **DEV backend**](https://dev-ccp1-api.classicaltesting.net/) runs at https://dev-ccp1-api.classicaltesting.net/. - [The **DEV frontend**](https://dev-ccp1.classicaltesting.net/) runs at https://dev-ccp1.classicaltesting.net/.  The TEST environment is similar, but with `test-` instead of `dev-`.
 *
 * The version of the OpenAPI document: 9302a31b (Tue Nov  3 17:38:29 UTC 2026)
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime'
import { Address, AddressFromJSON, AddressToJSON } from './'

/**
 *
 * @export
 * @interface UpdateCommunity
 */
export interface UpdateCommunity {
  /**
   * Community unique identifier
   * @type number
   * @memberof UpdateCommunity
   */
  communityKey: number
  /**
   * Name of the community.
   * @type string
   * @memberof UpdateCommunity
   */
  name: string
  /**
   * Unique region identifier for a foreign key relationship from community to region.
   * @type number
   * @memberof UpdateCommunity
   */
  regionsKey: number
  /**
   *
   * @type Address
   * @memberof UpdateCommunity
   */
  address: Address
  /**
   * The unique identifier of the actor of 'Support Representative' for this particular community
   * @type number
   * @memberof UpdateCommunity
   */
  actorKey: number
  /**
   * The unique identifier of the contractual model for a tutor. This model is configured at a community level and specifies how all tutors for a community's programs are hired.
   * @type string
   * @memberof UpdateCommunity
   */
  tutorModel: string
  /**
   * The percentage of fees that are given to the tutor based on the tutor model.
   * @type number
   * @memberof UpdateCommunity
   */
  feePercentage?: number
  /**
   * Indicates whether or not to update the address of the programs in the community
   * @type boolean
   * @memberof UpdateCommunity
   */
  updateProgramAddresses?: boolean
  /**
   * The hideFromPublicSearch prevents a community from being displayed on the marketing site.
   * @type boolean
   * @memberof UpdateCommunity
   */
  hideFromPublicSearch: boolean
  /**
   * Set to true to save a new actorKey even though some current directors of the community do not report to them.
   * @type boolean
   * @memberof UpdateCommunity
   */
  confirmDirectorMismatch?: boolean
}

export function UpdateCommunityFromJSON(json: any): UpdateCommunity {
  return UpdateCommunityFromJSONTyped(json, false)
}

export function UpdateCommunityFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): UpdateCommunity {
  if (json === undefined || json === null) {
    return json
  }
  return {
    communityKey: json['communityKey'],
    name: json['name'],
    regionsKey: json['regionsKey'],
    address: AddressFromJSON(json['address']),
    actorKey: json['actorKey'],
    tutorModel: json['tutorModel'],
    feePercentage: !exists(json, 'feePercentage')
      ? undefined
      : json['feePercentage'],
    updateProgramAddresses: !exists(json, 'updateProgramAddresses')
      ? undefined
      : json['updateProgramAddresses'],
    hideFromPublicSearch: json['hideFromPublicSearch'],
    confirmDirectorMismatch: !exists(json, 'confirmDirectorMismatch')
      ? undefined
      : json['confirmDirectorMismatch'],
  }
}

export function UpdateCommunityToJSON(value?: UpdateCommunity | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    communityKey: value.communityKey,
    name: value.name,
    regionsKey: value.regionsKey,
    address: AddressToJSON(value.address),
    actorKey: value.actorKey,
    tutorModel: value.tutorModel,
    feePercentage: value.feePercentage,
    updateProgramAddresses: value.updateProgramAddresses,
    hideFromPublicSearch: value.hideFromPublicSearch,
    confirmDirectorMismatch: value.confirmDirectorMismatch,
  }
}
